const objectivesState = {
  consumption: {
    amountsByPeriod: [],
  },
  updatedFixations: [],
};

export default objectivesState;
